import * as React from 'react'
import Navigation, { INavigationTarget } from './generic/Navigation'

interface IGinfoNavigationProps {
  mobile: boolean
  currentPath: string
}

const GinfoNavigation = ({ currentPath, mobile }: IGinfoNavigationProps) => {
  const navigationTarget = (path: string, text: string): INavigationTarget => {
    return {
      path, text, active: (path === currentPath),
    }
  }

  const navigationTargets: INavigationTarget[] = [
    navigationTarget('/profile', 'PROFILE'),
    navigationTarget('/', 'HEROES'),
    navigationTarget('/maps', 'MAPS'),
  ]
  if (mobile) {
    navigationTargets.push(navigationTarget('https://v5jmf.app.goo.gl/cffF', 'APP'))
  }
  else {
    navigationTargets.push(navigationTarget('https://play.google.com/store/apps/details?id=com.innovaptor.ginfo.overwatch', 'ANDROID'))
    navigationTargets.push(navigationTarget('https://itunes.apple.com/app/ginfo-overwatch-edition/id1116379106?mt=8', 'IOS'))
  }
  return <Navigation navigationTargets={navigationTargets}>
    <a href='#' className='left-distanced brand-logo'>
      <img src={require('../images/logo.svg')} alt='Ginfo Overwatch logo' className='brand-logo' />
    </a>
  </Navigation>
}

export default GinfoNavigation



// WEBPACK FOOTER //
// ./src/components/GinfoNavigation.tsx